import {
    byodServiceCode,
    removedStatus,
    addStatus,
    wowManagedStb,
    currentPortTypeTvPlus
} from '../constants/byodCodesConfig';

export const hasBYODServiceCode = equipmentDetails => {
    let hasByodCode = false;

    if (equipmentDetails) {
        equipmentDetails.forEach(equipment => {
            const serviceCodeList = equipment.get('serviceCodeList');
            if (serviceCodeList) {
                serviceCodeList.forEach(sc => {
                    const serviceCode = sc.get('code');
                    if (
                        byodServiceCode.includes(serviceCode && serviceCode.trim())
                    ) {
                        hasByodCode = true;
                    }
                });
            }
        });
    }

    return hasByodCode;
};

export const getCustomerOwnedFlag = equipmentDetails => {
    let customerOwnedFlag = false;

    if (equipmentDetails) {
        equipmentDetails.forEach(equipment => {
            const customerFlag = equipment.get('customerOwnedFlag');

            if (customerFlag) {
                customerOwnedFlag = true;
            }
        });
    }

    return customerOwnedFlag;
};

export const getCustomerOwnedOutlet = equipment => {
    let outlet = null;
    if (equipment) {
        const serviceCodeList = equipment.serviceCodeList;
        if (serviceCodeList) {
            serviceCodeList.forEach(sc => {
                const serviceCode = sc.code;
                if (
                    byodServiceCode.includes(serviceCode && serviceCode.trim()) && equipment.customerOwnedFlag
                ) {
                    outlet = equipment;
                    return outlet;
                }
            });
        }

    }
    return outlet;
};

export const getCustomerOwnedOutletNotBeingRemoved = equipment => {
    const byodOutletStatus = [];
    if (equipment) {
        const serviceCodeList = equipment.serviceCodeList;
        if (serviceCodeList) {
            serviceCodeList.forEach(sc => {
                const serviceCode = sc.code;
                const status = sc.status;
                if (byodServiceCode.includes(serviceCode && serviceCode.trim())) {
                    byodOutletStatus.push(status && status.toLowerCase().trim());
                }
            });
        }
    }

    return byodOutletStatus.length > 0 && (!byodOutletStatus.includes(removedStatus) || byodOutletStatus.includes(addStatus));
};

export const isOutletIpve = outlet => {
    let isIpve = false;

    if (outlet) {
        const currentPortType = outlet.currentPortType;

        if (currentPortType && currentPortTypeTvPlus.includes(currentPortType && currentPortType.trim())) {
            isIpve = true;
        }
    }

    return isIpve;
};

export const hasWowMangedSetUpBox = outlet => {
    return wowManagedStb.includes(outlet.model && outlet.model.trim());
};

export const isEquipmentSuccessfullyRemoved = equipmentDetails => {
    let removedEquipment = false;

    if (equipmentDetails) {
        equipmentDetails.forEach(equipment => {
            const equipmentUpdateResult = equipment.get('equipmentUpdateResult');

            if (equipmentUpdateResult && equipmentUpdateResult.get('isSuccess')) {
                removedEquipment = true;
            }
        });
    }

    return removedEquipment;
};



// WEBPACK FOOTER //
// ./src/utils/byodServiceCodeUtils.js